module.exports = __webpack_public_path__ + "static/media/Disgust.6f107385.png";